import React from 'react';
import { styled } from 'styled-components';
import { Button, Layout, Result } from 'antd';
import type { IEventBus } from '@shore/types';
import { PageLayout } from '../../../components/Layouts';
import { t } from '../../../utils/i18n';

const StyledContent = styled(Layout.Content)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.antd.colorWhite};
`;

const apiClient = {};
const eventBus: IEventBus = { on: () => {}, off: () => {}, emit: () => {} };
const trackMethod = () => {};

export function OfflinePage() {
  // TODO: Double check later this page and make sure it is covered with router
  return (
    <PageLayout
      apiClient={apiClient}
      eventBus={eventBus}
      trackMethod={trackMethod}
    >
      <StyledContent>
        <Result
          title={t('page-404.title')}
          subTitle={t('offline.description')}
          extra={
            <Button
              type="primary"
              target="_blank"
              href="https://shore.instatus.com/"
            >
              {t('offline.button.status-page')}
            </Button>
          }
        />
      </StyledContent>
    </PageLayout>
  );
}
